export const ConnectionStatus = {
  CREATED: 'CREATED',
  STARTED: 'STARTED',
  PAUSED: 'PAUSED'
};
export const SyncDirection = {
  BOTH: 'BOTH',
  INBOUND: 'INBOUND',
  OUTBOUND: 'OUTBOUND'
};